import React from 'react';
import FooterSection from '../../Footer/FooterSection';
import Navbar from '../../Navbar/Navbar';


function MobileViewLayout({ page }) {
    return (
        <div className="flex flex-col min-h-screen bg-background-primary-color">
            {/* Header with Navbar */}
            <header className="flex items-center p-4 bg-gray-100">
                <Navbar />
            </header>

            {/* Main Content Area */}
            {/* <main className="flex-1 p-6 bg-background-primary-color">
                <div className="bg-background-primary-color min-h-[280px] p-6">
                    {page}
                </div>
            </main> */}

            <main className="flex-1  bg-background-primary-color">
                <div className="bg-background-primary-color min-h-[280px] p-3 mt-5">
                    {page}
                </div>
            </main>

            {/* Footer */}
            <footer className="ml-[-250px] bg-gray-100 bg-background-primary-color">
                <FooterSection />
            </footer>
        </div>
    );
}

export default MobileViewLayout;
